import { getAvailableClusterZoomLevels } from './getAvailableClusterZoomLevels';

export const getFlowMagnitude = flow => flow.count || 0;
export const getFlowOriginId = flow => flow.origin;
export const getFlowDestId = flow => flow.dest;
export const getLocationId = loc => loc.id;
export const getLocationCentroid = loc => {
    if (typeof loc.centroid !== 'undefined' && Array.isArray(loc.centroid) && loc.centroid.length === 2 &&
        loc.centroid[0] !== null && loc.centroid[1] !== null &&
        !isNaN(loc.centroid[0]) && !isNaN(loc.centroid[1])) {
        return loc.centroid;
    }

    if (loc.lon !== null && loc.lat !== null && !isNaN(loc.lon) && !isNaN(loc.lat)) {
        return [ loc.lon, loc.lat ];
    }

    return null;
};

export const getClusterZoom = (clusterIndex, zoom, selectedLocationsSet) => {
    if (!clusterIndex || !clusterIndex.availableZoomLevels) {
        console.warn('Invalid cluster index provided to getClusterZoom');
        return null;
    }

    const availableZoomLevels = clusterIndex.availableZoomLevels;

    if (!availableZoomLevels || availableZoomLevels.length === 0) {
        console.warn('No available zoom levels in cluster index');
        return null;
    }

    if (selectedLocationsSet.size) {
        const filteredZoomLevels = getAvailableClusterZoomLevels(clusterIndex, selectedLocationsSet);

        if (filteredZoomLevels.length === 0) {
            console.warn('No available zoom levels for selected locations');
            // Fallback to first available zoom level
            return availableZoomLevels[0];
        }

        return filteredZoomLevels[0];
    }

    // Find the best zoom level for the current map zoom
    const targetZoom = Math.floor(zoom);
    // Find the closest available zoom level
    const closestZoom = availableZoomLevels.reduce((closest, level) => {
        return Math.abs(level - targetZoom) < Math.abs(closest - targetZoom) ? level : closest;
    });

    return closestZoom;
};

export const getMixBlendMode = mapStyle => {
    switch (mapStyle) {
        case 'dark':
            return 'screen';
        case 'basic':
        case 'outdoors':
            return 'difference';
        default:
            return null;
    }
};

export const isFlowInSelection = (flow, selectedLocationsSet) => {
    if (selectedLocationsSet.size === 0) {
        return true;
    }

    return selectedLocationsSet.has(flow.origin) || selectedLocationsSet.has(flow.dest);
};
